import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { SharedModule } from '../shared/shared.module';
import { BillingDataBuilder } from './billing-data.builder';
import { BillingDataDispatcher } from './billing-data.dispatcher';
import { BillingDataEffects } from './billing-data.effects';
import { FEATURE_NAME, reducer } from './billing-data.reducer';
import { BillingDataService } from './billing-data.service';
import { BillingDataStore } from './billing-data.store';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(FEATURE_NAME, reducer),
    EffectsModule.forFeature([BillingDataEffects]),
  ],
  declarations: [],
})
export class BillingDataModule {
  static forRoot(): ModuleWithProviders<BillingDataModule> {
    return {
      ngModule: BillingDataModule,
      providers: [
        BillingDataService,
        BillingDataBuilder,
        BillingDataStore,
        BillingDataDispatcher,
      ],
    };
  }
}
